import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '@shared/api'

export const useSecretaryStore = defineStore('secretary', () => {
  const forms = ref([])
  const applications = ref([])
  const pagination = ref({})
  const statusCounts = ref({})
  const educationLevelCounts = ref({})
  const contractCounts = ref({})
  const form = ref({})
  const loading = ref(false)

  const fetchForms = async (params = {}) => {
    loading.value = true
    try {
      const { data } = await api.get('/api/v1/secretary/forms', { params })
      applications.value = data.applications
      pagination.value = data.pagination
      statusCounts.value = data.status_counts ?? {}
      educationLevelCounts.value = data.education_level_counts ?? {}
      contractCounts.value = data.contract_counts ?? {}
    } finally {
      loading.value = false
    }
  }

  const fetchForm = async (id) => {
    const { data } = await api.get(`/api/v1/secretary/forms/${id}`)
    form.value = data.form
    applications.value = data.applications
  }

  return {
    forms, applications, pagination, statusCounts, educationLevelCounts, contractCounts, form, loading,
    fetchForms, fetchForm
  }
})
